<template>
    <div
        class="modal fade text-left delete_popup"
        :id="target"
        tabindex="-1"
        role="dialog"
        aria-labelledby="basicModalLabel3"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header border-0 bg-lightblue">
                    <h4 class="modal-title" id="basicModalLabel3">
                        Are you sure you want to delete?
                    </h4>
                    <button
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        class="close"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </button>
                </div>
                <div class="modal-body text-center pb-0">
                    <p>Do you really want to delete these record?</p>
                </div>
                <div
                    class="modal-footer text-center justify-content-center align-items-center pb_36 border-0"
                >
                    <button
                        type="button"
                        @click="removeResoursce"
                        class="btn btn-outline-primary mr_10"
                    >
                        Yes
                    </button>
                    <button
                        type="button"
                        class="btn btn_primary bg_primary_blue text_white"
                        data-dismiss="modal"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
    name: "DeleteResource",
    props: ["path", "target", "method", "post_data", "message"],
    methods: {
        removeResoursce() {
            // console.log(this.target);
            var _this = this;
            /* eslint-disable */
            new Promise(() => {
                if (_this.method == "get") {
                    ApiService.get(this.path)
                        .then(({ data }) => {
                            console.log(data);
                            if (data.success) {
                                this.$emit("updatelist");
                                $("#" + this.target).modal("hide");
                                _this.$toast.error(
                                    "Record deleted successfully.",
                                    {
                                        position: "top-right"
                                    }
                                );
                            }
                        })
                        .catch(({ response }) => {
                            context.commit(SET_ERROR, response.data.errors);
                        });
                } else if (_this.method == "post") {
                    ApiService.post(this.path, _this.post_data)
                        .then(({ data }) => {
                            console.log(data);
                            if (data.success) {
                                this.$emit("updatelist");
                                $("#" + this.target).modal("hide");
                                _this.$toast.error(_this.message, {
                                    position: "top-right"
                                });
                            }
                        })
                        .catch(({ response }) => {
                            context.commit(SET_ERROR, response.data.errors);
                        });
                } else {
                    ApiService.delete(this.path)
                        .then(({ data }) => {
                            console.log(data);
                            if (data.success) {
                                this.$emit("updatelist");
                                $("#" + this.target).modal("hide");
                                _this.$toast.error(
                                    "Record deleted successfully.",
                                    {
                                        position: "top-right"
                                    }
                                );
                            }
                        })
                        .catch(({ response }) => {
                            context.commit(SET_ERROR, response.data.errors);
                        });
                }
                /* eslint-enable */
            });
        }
    }
};
</script>
